/* Carol & Margaret: kortingsbalk in de winkelwagen + sticky "Add to cart". */
(function () {
  var TIERS = [{ min: 2, pct: 10 }, { min: 3, pct: 15 }, { min: 4, pct: 20 }, { min: 5, pct: 25 }];
  var fmt = function (cents) {
    var c = (window.theme && theme.settings && theme.settings.moneyFormat) || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    return c.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  };

  function paint(count, discount, original) {
    var box = document.getElementById('CmTiers');
    if (!box) return;
    var msg = document.getElementById('CmTiersMsg'), fill = document.getElementById('CmTiersFill');
    var cur = null, next = null;
    TIERS.forEach(function (t) { if (count >= t.min) cur = t; else if (!next) next = t; });
    if (count === 0) msg.textContent = 'Shipping is free on every U.S. order. Add 2 items to save 10%.';
    else if (!cur) msg.innerHTML = 'Add <b>1 more item</b> and get <b>10% off</b> your order';
    else if (next) msg.innerHTML = '<b>' + cur.pct + '% off</b> unlocked! Add <b>' + (next.min - count) + ' more</b> for <b>' + next.pct + '% off</b>';
    else msg.innerHTML = 'You unlocked our best deal: <b>25% off</b> everything in your cart';
    var steps = box.querySelectorAll('.cm-tiers__steps li');
    steps.forEach(function (li) { li.classList.toggle('is-done', count >= Number(li.getAttribute('data-min'))); });
    var pos = Math.min(count, 5);
    fill.style.width = (pos <= 1 ? (pos ? 0 : 0) : (pos - 1) / 4 * 100) + '%';
    box.classList.toggle('is-unlocked', !!cur);
    var row = document.getElementById('CmSavings');
    if (row) {
      var show = discount > 0 && count >= 2;
      row.hidden = !show;
      if (show) {
        var pct = original ? Math.round(discount / original * 100) : (cur ? cur.pct : 0);
        document.getElementById('CmSavingsAmt').textContent = '-' + fmt(discount);
        document.getElementById('CmSavingsPct').textContent = pct ? '(' + pct + '%)' : '';
      }
    }
  }

  // "Add one more": geen producten tonen die al in de winkelwagen zitten (ook na toevoegen zonder herladen)
  function upsell(c) {
    var box = document.getElementById('CmUpsell');
    if (!box || !c || !c.items) return;
    var inCart = c.items.map(function (i) { return String(i.product_id); }), zichtbaar = 0;
    box.querySelectorAll('.cm-upsell__item[data-product-id]').forEach(function (el) {
      var weg = inCart.indexOf(el.getAttribute('data-product-id')) > -1;
      el.style.display = weg ? 'none' : ''; if (!weg) zichtbaar++;
    });
    box.style.display = zichtbaar ? '' : 'none';
  }

  var busy = null;
  function refresh() {
    clearTimeout(busy);
    busy = setTimeout(function () {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { paint(c.item_count || 0, c.total_discount || 0, c.original_total_price || 0); upsell(c); })
        .catch(function () {});
    }, 150);
  }

  function init() {
    var box = document.getElementById('CmTiers');
    if (box) paint(Number(box.dataset.count || 0), Number(box.dataset.discount || 0), Number(box.dataset.original || 0));
    document.addEventListener('cart:updated', function (e) {
      var c = e && e.detail && e.detail.cart;
      if (c && typeof c.item_count === 'number') paint(c.item_count, c.total_discount || 0, c.original_total_price || 0);
      refresh();
    });
    ['ajaxProduct:added', 'cart:open'].forEach(function (e) { document.addEventListener(e, refresh); });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('#CartDrawer .js-qty__adjust, #CartDrawer [data-remove], #CartDrawer .cart__remove')) setTimeout(refresh, 600); });
    var list = document.getElementById('CartDrawer');
    if (list && window.MutationObserver) new MutationObserver(function (m) { if (m.some(function (x) { return !(x.target.closest && x.target.closest('#CmTiers, #CmSavings')); })) refresh(); }).observe(list, { childList: true, subtree: true, characterData: true });
    refresh();
    initSticky();
  }

  function initSticky() {
    var bar = document.getElementById('CmSticky');
    if (!bar) return;
    var data = [];
    try { data = JSON.parse(document.getElementById('CmStickyData').textContent); } catch (e) { return; }
    var selects = bar.querySelectorAll('select[data-index]'), price = bar.querySelector('[data-price]'), was = bar.querySelector('[data-was]'),
        btn = bar.querySelector('[data-add]'), img = bar.querySelector('[data-img]');
    var form = document.querySelector('form[action*="/cart/add"][id^="AddToCartForm"], .product-single__form, form[action*="/cart/add"]');
    var mainBtn = form && form.querySelector('[type="submit"], [name="add"]');
    function current() {
      var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
      return data.find(function (v) { return v.options.every(function (o, i) { return opts[i] === undefined || o === opts[i]; }); });
    }
    function update() {
      var v = current();
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      price.textContent = v.price; was.textContent = v.compare || ''; was.hidden = !v.compare;
      if (v.image && img) img.src = v.image;
      btn.disabled = !v.available; btn.textContent = v.available ? btn.getAttribute('data-label') : 'Sold out';
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
    btn.addEventListener('click', function () {
      var v = current(); if (!v || !v.available) return;
      btn.disabled = true;
      var idField = form && form.querySelector('[name="id"]');
      if (form && idField && typeof form.requestSubmit === 'function') {
        if (idField.tagName === 'SELECT' && !idField.querySelector('option[value="' + v.id + '"]')) { var o = document.createElement('option'); o.value = v.id; idField.appendChild(o); }
        idField.value = String(v.id);
        form.requestSubmit(mainBtn || undefined);
        setTimeout(function () { btn.disabled = false; update(); }, 1500);
        return;
      }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: v.id, quantity: 1 }) })
        .then(function () { document.dispatchEvent(new CustomEvent('cart:build')); document.dispatchEvent(new CustomEvent('cart:open')); refresh(); })
        .finally(function () { btn.disabled = false; update(); });
    });
    if (mainBtn && window.IntersectionObserver) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(mainBtn);
    } else {
      window.addEventListener('scroll', function () { bar.classList.toggle('is-visible', window.scrollY > 700); }, { passive: true });
    }
  }

  // Snel toevoegen vanuit "Add one more and save more" in de winkelwagen
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-upsell-add]');
    if (!b) return;
    e.preventDefault();
    var item = b.closest('.cm-upsell__item'), sel = item && item.querySelector('.cm-upsell__var');
    if (!sel || !sel.value) return;
    b.disabled = true; b.textContent = 'Adding…';
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(sel.value), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        b.textContent = 'Added ✓'; item.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('cart:build'));
        refresh();
        setTimeout(function () { b.disabled = false; b.textContent = '+ Add'; }, 1800);
      })
      .catch(function () { b.disabled = false; b.textContent = 'Try again'; });
  });

  // Maattabel (cm-size-chart): <template> naar body verplaatsen en als dialoog openen
  document.addEventListener('click', function (e) {
    var open = e.target.closest && e.target.closest('[data-cm-sc-open]');
    if (open) {
      e.preventDefault(); e.stopPropagation();
      var id = open.getAttribute('data-cm-sc-open'), dlg = document.querySelector('dialog[data-sc="' + id + '"]');
      if (!dlg) {
        var tpl = document.getElementById(id); if (!tpl) return;
        dlg = tpl.content.firstElementChild.cloneNode(true); dlg.setAttribute('data-sc', id); document.body.appendChild(dlg);
        dlg.addEventListener('click', function (ev) {
          if (ev.target === dlg || (ev.target.closest && ev.target.closest('[data-cm-sc-close]'))) dlg.close();
          var u = ev.target.closest && ev.target.closest('[data-unit]');
          if (u) {
            var cm = u.getAttribute('data-unit') === 'cm';
            dlg.querySelectorAll('[data-unit]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === u)); });
            dlg.querySelectorAll('[data-u-in]').forEach(function (s) { s.hidden = cm; });
            dlg.querySelectorAll('[data-u-cm]').forEach(function (s) { s.hidden = !cm; });
          }
        });
      }
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
